import React, { useEffect } from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { Helmet } from "react-helmet";
import Banner from "../assets/images/privacy-policy/Banner.webp";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Terms & Conditions | Huntsville Islamic Center</title>
        <script src="https://widget-cdn.simplepractice.com/assets/integration-1.0.js"></script>
      </Helmet>
      <section id="website-responsive" className="px-0">
        <section
          className="container-fluid bg-common-banner"
          style={{ backgroundImage: `url(${Banner})` }}
        >
          <Header />
          <div className="fs-banner-title text-white fw-500 text-center py-5">
            <div className="py-md-5 mb-md-5">Terms & Conditions</div>
          </div>
        </section>
        <div className="py-4 py-md-5" />

        <section className="container-fluid">
          <div className="row justify-content-evenly">
            <div className="col-11 col-md-10 mx-auto">
              <div className="pb-4 ">
                <div className="pb-2 text-dark lh-sm fw-600 fs-ss-28">
                  Terms and Conditions for SMS Messaging
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  By opting in to receive SMS messages from Huntsville Islamic
                  Center (HIC), you agree to the following terms:
                </div>
              </div>

              <div className="pb-4 ">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  1. Types of Messages You May Receive
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  <ul className="mt-2">
                    <li>Prayer time reminders</li>
                    <li>Event announcements</li>
                    <li>Facility access updates</li>
                    <li>School or program communication</li>
                    <li>Donation acknowledgments</li>
                    <li>Customer service replies</li>
                  </ul>
                </div>
              </div>

              <div className="pb-4 ">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  2. Message Frequency
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  Message frequency varies. You may receive several messages per
                  week depending on your involvement in our services.
                </div>
              </div>

              <div className="pb-4 ">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  3. Message & Data Rates
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  Standard message and data rates may apply. Check with your
                  mobile carrier for details.
                </div>
              </div>

              <div className="pb-4 ">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  4. Opt-Out
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  You may opt out at any time by replying <b> STOP </b> to any
                  message. You will receive one final confirmation message.
                </div>
              </div>

              <div className="pb-4 ">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  5. Help
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  For help, reply <b> HELP </b> or visit our website at{" "}
                  <a
                    href="https://huntsvilleislamiccenter.org"
                    className="text-decoration-none"
                  >
                    https://huntsvilleislamiccenter.org
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="py-4 py-md-5" />

        <Footer />
      </section>
    </>
  );
};

export default TermsAndConditions;
